export const fornitoreLogoLocalStorageKey = 'fornitoreLogo';
export const fornitoreNomeLocalStorageKey = 'fornitoreNome';
export const fornitoreFaviconLocalStorageKey = 'fornitoreFavicon';
export const fornitorePermessiLocalStorageKey = 'fornitorePermessi';
export const fornitoreFallbackUrlKey = 'fornitoreFallbackUrl';
